import React from 'react'
import { Box, DataListItem } from '@node-space/ui-components'
import { ellipseMiddleText } from '@node-space/utils'
import { DepositDetails } from 'types/transaction'
import { useTranslation } from 'react-i18next'

interface FiatDepositProps {
  depositDetails: DepositDetails
  amountWithCurrency: string
  transactionReference: string
  transactionDate: string
}

const FiatDeposit = ({
  depositDetails,
  amountWithCurrency,
  transactionReference,
  transactionDate,
}: FiatDepositProps) => {
  const { t } = useTranslation()

  return (
    <>
      <DataListItem
        id="amount-with-currency"
        testId="amount-with-currency"
        title={t('transactions.sideBar.paymentInAmountReceived')}
        body={amountWithCurrency}
      />
      {!!transactionReference && (
        <DataListItem
          id="transaction-reference"
          testId="transaction-reference"
          title={t('transactions.sideBar.reference')}
          body={ellipseMiddleText(transactionReference, 20, 10)}
          copyText={transactionReference}
        />
      )}
      {!!depositDetails?.senderReference && transactionReference !== depositDetails.senderReference && (
        <DataListItem
          id="customer-reference"
          testId="customer-reference"
          title={t('customerReference')}
          body={ellipseMiddleText(depositDetails.senderReference, 20, 10)}
          copyText={depositDetails.senderReference}
        />
      )}
      <DataListItem
        id="transaction-date"
        testId="transaction-date"
        title={t('date')}
        body={transactionDate}
      />
      <p className="text-h4 text-foreground-prominent mt-3">{t('senderDetails')}</p>
      <Box gapY={8}>
        {!!depositDetails?.senderAccountNumber && (
          <DataListItem
            id="sender-account-number"
            testId="sender-account-number"
            title={t('walletsPage.fromBankAccountNo')}
            body={depositDetails?.senderAccountNumber}
          />
        )}
        {depositDetails?.senderBankCode && (
          <DataListItem
            id="sender-bank-code"
            testId="sender-bank-code"
            title={t('walletsPage.fromBankCode')}
            body={depositDetails?.senderBankCode}
          />
        )}
        {depositDetails?.senderName && (
          <DataListItem
            id="sender-name"
            testId="sender-name"
            title={t('walletsPage.receivedFrom')}
            body={depositDetails?.senderName}
          />
        )}
      </Box>
    </>
  )
}

export default FiatDeposit
